function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.6514 50H1.46484C0.655746 50 0 49.3443 0 48.5352V7.34863C0 6.53954 0.655746 5.88379 1.46484 5.88379H42.6025C43.4464 5.88379 44.1162 6.61163 44.1162 7.39784V48.5352C44.1162 49.3443 43.4605 50 42.6514 50Z",
  fill: "#1ED760"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.6025 5.88379H22.0585V50H42.6514C43.4601 50 44.1162 49.3439 44.1162 48.5352V7.39746C44.1162 6.60934 43.4433 5.88379 42.6025 5.88379Z",
  fill: "#1DB954"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48.5352 44.1162H7.34863C6.53954 44.1162 5.88379 43.4605 5.88379 42.6514V1.46484C5.88379 0.655746 6.53954 0 7.34863 0H48.5352C49.3443 0 50 0.655746 50 1.46484V42.6514C50 43.4605 49.3443 44.1162 48.5352 44.1162Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M48.5352 0H27.9774V44.1162H48.5352C49.3439 44.1162 50 43.4601 50 42.6514V1.46484C50 0.656128 49.3439 0 48.5352 0Z",
  fill: "#A3A3A3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9419 38.2324C19.0235 38.2324 11.7676 30.9765 11.7676 22.0581C11.7676 13.1397 19.0235 5.88379 27.9419 5.88379C36.8603 5.88379 44.1162 13.1397 44.1162 22.0581C44.1162 30.9765 36.8603 38.2324 27.9419 38.2324Z",
  fill: "#1ED760"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9774 5.88379V38.2324C36.8797 38.213 44.1162 30.9647 44.1162 22.0585C44.1162 13.1516 36.8797 5.90324 27.9774 5.88379V5.88379Z",
  fill: "#1DB954"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4835 13.5086L28.648 11.9488C27.673 11.4128 26.4771 12.1193 26.4771 13.2324V23.6332H24.9939C22.5891 23.6332 20.5933 25.5806 20.5933 28.046C20.5933 30.4508 22.5407 32.4467 25.0061 32.4467C27.4326 32.4467 29.4067 30.4726 29.4067 28.046C29.4067 27.747 29.4067 15.7661 29.4067 15.7097L30.0716 16.0755C31.4835 16.8522 32.3608 18.3357 32.3608 19.9474V22.0581C32.3608 22.8668 33.0166 23.5229 33.8257 23.5229C34.6348 23.5229 35.2905 22.8668 35.2905 22.0581V19.9474C35.2905 17.2672 33.8318 14.7999 31.4835 13.5086V13.5086Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M35.2909 19.9474V22.0585C35.2909 22.8672 34.6348 23.5233 33.8261 23.5233C33.0166 23.5233 32.3612 22.8672 32.3612 22.0585V19.9474C32.3612 18.3361 31.4835 16.8526 30.0713 16.0751L29.4064 15.7101V28.046C29.4064 29.3282 28.8555 30.4832 27.9774 31.2881V11.7687C28.4512 11.7786 28.4115 11.8195 31.4835 13.5086C33.8322 14.7999 35.2909 17.2676 35.2909 19.9474V19.9474Z",
  fill: "#A3A3A3"
});

function SvgAlbum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbum);
export default __webpack_public_path__ + "static/media/album.6f47d611.svg";
export { ForwardRef as ReactComponent };